import { jsx as o } from "react/jsx-runtime";
import { ContainerSkeletonDefault as r } from "./style.js";
const l = ({
  animate: e,
  className: t
}) => /* @__PURE__ */ o(r, { animate: e, className: t });
export {
  l as DealCardDefaultSkeleton
};
